import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('REFERRAL_REQUEST_UNASSIGN')